var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('tire'),(_vm.i18n.locale === 'en')?_c('news-section',{attrs:{"news":_vm.news}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }